var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9991 86.3248C57.4341 86.3248 61.0293 82.7296 61.0293 78.2946C61.0293 73.8597 57.4341 70.2644 52.9991 70.2644C48.5641 70.2644 44.9689 73.8597 44.9689 78.2946C44.9689 82.7296 48.5641 86.3248 52.9991 86.3248Z",
    stroke: "white",
    strokeWidth: 6.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8845 55.4091C69.8619 49.7879 61.8317 46.1743 52.9984 46.1743C44.1652 46.1743 36.135 49.7879 30.1123 55.4091",
    stroke: "white",
    strokeWidth: 6.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7491 38.5452C82.7114 28.5074 68.6585 22.0833 52.9996 22.0833C37.3406 22.0833 23.2878 28.5074 13.25 38.5452",
    stroke: "white",
    strokeWidth: 6.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.a992674f.svg";
export { ForwardRef as ReactComponent };